const DEVICE_TYPE_METER = "peripheral_energymeter";
const DEVICE_TYPE_DTU = "DEVICE_TYPE_DTU";
const DEVICE_TYPE_OTHER = "DEVICE_TYPE_OTHER";
const DEVICE_TYPE_DLC = "peripheral_dynamiccontroller";

const DEVICE_TYPES = {
  POWER_METER: DEVICE_TYPE_METER,
  DTU: DEVICE_TYPE_DTU,
  OTHER: DEVICE_TYPE_OTHER
};

const DEVICE_TYPE_LABELS = {
  [DEVICE_TYPE_METER]: "device.type.powerMeter",
  [DEVICE_TYPE_DTU]: "device.type.dtu",
  [DEVICE_TYPE_OTHER]: "device.type.other",
  [DEVICE_TYPE_DLC]:"device.type.dlc"
};

const DEVICE_FIRMWARE_NONE_LABEL = "device.firmware.none";

const DEVICE_SITE_NOT_ALLOCATED = "DEVICE_SITE_NOT_ALLOCATED";
const DEVICE_SITE_LABELS = {
  [DEVICE_SITE_NOT_ALLOCATED]: "device.site.notAllocated"
};

const DEVICE_DATA_LATENCY_FOUR_HOURS = "DATA_LATENCY_FOUR_HOURS";
const DEVICE_DATA_LATENCY_ONE_HOUR = "DATA_LATENCY_ONE_HOUR";
const DEVICE_DATA_LATENCY_HALF_HOUR = "DATA_LATENCY_HALF_HOUR";
const DEVICE_DATA_LATENCY_FIVE_SECONDS = "DATA_LATENCY_FIVE_SECONDS";

const DEVICE_DATA_LATENCIES = {
  FOUR_HOURS: DEVICE_DATA_LATENCY_FOUR_HOURS,
  ONE_HOUR: DEVICE_DATA_LATENCY_ONE_HOUR,
  HALF_HOUR: DEVICE_DATA_LATENCY_HALF_HOUR,
  FIVE_SECONDS: DEVICE_DATA_LATENCY_FIVE_SECONDS
};

const DEVICE_DATA_LATENCY_LABELS = {
  [DEVICE_DATA_LATENCY_FOUR_HOURS]: "device.data.latency.fourHours",
  [DEVICE_DATA_LATENCY_ONE_HOUR]: "device.data.latency.oneHour",
  [DEVICE_DATA_LATENCY_HALF_HOUR]: "device.data.latency.halfHour",
  [DEVICE_DATA_LATENCY_FIVE_SECONDS]: "device.data.latency.fiveSeconds"
};

// const DEVICE_WIRING_1PH2W = "1PH2W";
// const DEVICE_WIRING_3PH3W = "3PH3W";
// const DEVICE_WIRING_3PH4W = "3PH4W";

const DEVICE_WIRING_1PH2W = 0;
const DEVICE_WIRING_3PH3W = 1;
const DEVICE_WIRING_3PH4W = 2;

const DEVICE_WIRINGS = {
  "1PH2W": DEVICE_WIRING_1PH2W,
  "3PH3W": DEVICE_WIRING_3PH3W,
  "3PH4W": DEVICE_WIRING_3PH4W
};

const DEVICE_WIRINGS_ARRAY = Object.values(DEVICE_WIRINGS);

const DEVICE_WIRING_LABELS = {
  [DEVICE_WIRING_1PH2W]: "1PH2W",
  [DEVICE_WIRING_3PH3W]: "3PH3W",
  [DEVICE_WIRING_3PH4W]: "3PH4W"
};

// const DEVICE_BR_VALUES = {
//   "4800": "4800",
//   "9600": "9600",
//   "19200": "19200"
// };

const DEVICE_DI_SETUP_DISABLED = 0;
const DEVICE_DI_SETUP_ENABLED = 1;

const DEVICE_DI_SETUP_VALUES = {
  DISABLED: DEVICE_DI_SETUP_DISABLED,
  ENABLED: DEVICE_DI_SETUP_ENABLED
};

const DEVICE_DI_SETUP_VALUES_ARRAY = Object.values(DEVICE_DI_SETUP_VALUES);

const DEVICE_DI_SETUP_LABELS = {
  [DEVICE_DI_SETUP_DISABLED]: "device.DI.setup.disabled",
  [DEVICE_DI_SETUP_ENABLED]: "device.DI.setup.enabled"
};




const DEVICE_BR_4800 = 1;
const DEVICE_BR_9600 = 0;
const DEVICE_BR_19200 = 2;

const DEVICE_BR_VALUES = {
  BR4800: DEVICE_BR_4800,
  BR9600: DEVICE_BR_9600,
  BR19200: DEVICE_BR_19200
};

const DEVICE_BR_VALUES_ARRAY = Object.values(DEVICE_BR_VALUES);

const DEVICE_BR_LABELS = {
  [DEVICE_BR_4800]: "device.BR.4800",
  [DEVICE_BR_9600]: "device.BR.9600",
  [DEVICE_BR_19200]: "device.BR.19200"
};


// const DEVICE_STOP_ODD = "DEVICE_STOP_ODD";
// const DEVICE_STOP_DUAL = "DEVICE_STOP_DUAL";
// const DEVICE_STOP_NONE = "DEVICE_STOP_NONE";
const DEVICE_STOP_1 = 1;
const DEVICE_STOP_2 = 2;
const DEVICE_STOP_NONE = 0;

const DEVICE_STOP_VALUES = {
  ODD: DEVICE_STOP_1,
  DUAL: DEVICE_STOP_2,
  NONE: DEVICE_STOP_NONE
};

const DEVICE_STOP_VALUES_ARRAY = Object.values(DEVICE_STOP_VALUES);

const DEVICE_STOP_LABELS = {
  [DEVICE_STOP_1]: "device.stop.one",
  [DEVICE_STOP_2]: "device.stop.two",
  [DEVICE_STOP_NONE]: "device.stop.none"
};

const DEVICE_PARITY_ODD = 1;
const DEVICE_PARITY_DUAL = 2;
const DEVICE_PARITY_NONE = 0;

const DEVICE_PARITY_VALUES = {
  ODD: DEVICE_PARITY_ODD,
  DUAL: DEVICE_PARITY_DUAL,
  NONE: DEVICE_PARITY_NONE
};

const DEVICE_PARITY_VALUES_ARRAY = Object.values(DEVICE_STOP_VALUES);

const DEVICE_PARITY_LABELS = {
  [DEVICE_PARITY_ODD]: "device.parity.odd",
  [DEVICE_PARITY_DUAL]: "device.parity.dual",
  [DEVICE_PARITY_NONE]: "device.parity.none"
};


const DEVICE_NETWORK_TYPE_WIFI = "DEVICE_NETWORK_TYPE_WIFI";
const DEVICE_NETWORK_TYPE_CELLULAR = "DEVICE_NETWORK_TYPE_CELLULAR";

const DEVICE_NETWORK_TYPES = {
  WIFI: DEVICE_NETWORK_TYPE_WIFI,
  CELLULAR: DEVICE_NETWORK_TYPE_CELLULAR
};

const DEVICE_NETWORK_TYPE_LABELS = {
  [DEVICE_NETWORK_TYPE_WIFI]: "device.network.type.wifi",
  [DEVICE_NETWORK_TYPE_CELLULAR]: "device.network.type.cellular"
};

const DEVICE_NETWORK_STATUS_ONLINE = "DEVICE_NETWORK_STATUS_ONLINE";
const DEVICE_NETWORK_STATUS_OFFLINE = "DEVICE_NETWORK_STATUS_OFFLINE";

const DEVICE_NETWORK_STATUES = {
  ONLINE: DEVICE_NETWORK_STATUS_ONLINE,
  OFFLINE: DEVICE_NETWORK_STATUS_OFFLINE
};

const DEVICE_NETWORK_STATUS_LABELS = {
  [DEVICE_NETWORK_STATUS_ONLINE]: "device.network.status.online",
  [DEVICE_NETWORK_STATUS_OFFLINE]: "device.network.status.offline"
};

const DEVICE_NETWORK_SERVICE_PROVIDER_TELSTRA = "DEVICE_NETWORK_SERVICE_PROVIDER_TELSTRA";
const DEVICE_NETWORK_SERVICE_PROVIDER_OPTUS = "DEVICE_NETWORK_SERVICE_PROVIDER_OPTUS";
const DEVICE_NETWORK_SERVICE_PROVIDER_VODAFONE = "DEVICE_NETWORK_SERVICE_PROVIDER_VODAFONE";
const DEVICE_NETWORK_SERVICE_PROVIDER_USER = "DEVICE_NETWORK_SERVICE_PROVIDER_USER";

const DEVICE_NETWORK_SERVICE_PROVIDERS = {
  TELSTRA: DEVICE_NETWORK_SERVICE_PROVIDER_TELSTRA,
  OPTUS: DEVICE_NETWORK_SERVICE_PROVIDER_OPTUS,
  VODAFONE: DEVICE_NETWORK_SERVICE_PROVIDER_VODAFONE
};

const DEVICE_NETWORK_SERVICE_PROVIDER_LABELS = {
  [DEVICE_NETWORK_SERVICE_PROVIDER_TELSTRA]: "device.network.service.provider.telstra",
  [DEVICE_NETWORK_SERVICE_PROVIDER_OPTUS]: "device.network.service.provider.optus",
  [DEVICE_NETWORK_SERVICE_PROVIDER_VODAFONE]: "device.network.service.provider.vodafone",
  [DEVICE_NETWORK_SERVICE_PROVIDER_USER]: "device.network.service.provider.user",
};

const DEVICE_NETWORK_SIGNAL_STRENGTH_VALUES = [20, 50, 100, 200, 400];

const DEVICE_CONFIG_STATUS = {
  SUBMITTED: "Submitted",
  UPDATED: "Updated",
  FAILED: "Failed"
};

const DEVICE_DEMAND_METHOD_SLIDING = 1;
const DEVICE_DEMAND_METHOD_FIXED = 2
const DEVICE_DEMAND_METHOD_OFF = 0;

const DEVICE_DEMAND_METHODS = {
  SLIDING: DEVICE_DEMAND_METHOD_SLIDING,
  FIXED: DEVICE_DEMAND_METHOD_FIXED,
  OFF: DEVICE_DEMAND_METHOD_OFF
};

const DEVICE_DEMAND_METHODS_ARRAY = Object.values(DEVICE_DEMAND_METHODS);

const DEVICE_DEMAND_METHODS_LABELS = {
  [DEVICE_DEMAND_METHOD_SLIDING]: "device.demand.method.sliding",
  [DEVICE_DEMAND_METHOD_FIXED]: "device.demand.method.fixed",
  [DEVICE_DEMAND_METHOD_OFF]: "device.demand.method.off"
};

const DEVICE_DEMAND_INTERVAL_TEN_MINS = 1;
const DEVICE_DEMAND_INTERVAL_FIFTEEN_MINS = 2;
const DEVICE_DEMAND_INTERVAL_TWENTY_MINS = 3;
const DEVICE_DEMAND_INTERVAL_THIRTY_MINS = 4;
const DEVICE_DEMAND_INTERVAL_SIXTY_MINS = 5;

const DEVICE_DEMAND_INTERVALS = {
  TEN_MINS: DEVICE_DEMAND_INTERVAL_TEN_MINS,
  FIFTEEN_MINS: DEVICE_DEMAND_INTERVAL_FIFTEEN_MINS,
  TENTY_MINS: DEVICE_DEMAND_INTERVAL_TWENTY_MINS,
  THIRTY_MINS: DEVICE_DEMAND_INTERVAL_THIRTY_MINS,
  SIXTY_MINS: DEVICE_DEMAND_INTERVAL_SIXTY_MINS
};

const DEVICE_DEMAND_INTERVALS_ARRAY = Object.values(DEVICE_DEMAND_INTERVALS);

const DEVICE_DEMAND_INTERVAL_LABELS = {
  [DEVICE_DEMAND_INTERVAL_TEN_MINS]: "device.demand.interval.tenMins",
  [DEVICE_DEMAND_INTERVAL_FIFTEEN_MINS]: "device.demand.interval.fifteenMins",
  [DEVICE_DEMAND_INTERVAL_TWENTY_MINS]: "device.demand.interval.twentyMins",
  [DEVICE_DEMAND_INTERVAL_THIRTY_MINS]: "device.demand.interval.thirtyMins",
  [DEVICE_DEMAND_INTERVAL_SIXTY_MINS]: "device.demand.interval.sixtyMins"
};

const DEVICE_MAIN_SEL_C1 = 1;
const DEVICE_MAIN_SEL_C2 = 2;
const DEVICE_MAIN_SEL_C3 = 3;
const DEVICE_MAIN_SEL_C4 = 4;
const DEVICE_MAIN_SEL_C5 = 5;
const DEVICE_MAIN_SEL_C6 = 6;
const DEVICE_MAIN_SEL_C123 = 11;
const DEVICE_MAIN_SEL_C456 = 14;
const DEVICE_MAIN_SEL_OFF = 0;
const DEVICE_MAIN_SEL_NONE = 999;

const DEVICE_MAIN_SELS = {
  C1: DEVICE_MAIN_SEL_C1,
  C2: DEVICE_MAIN_SEL_C2,
  C3: DEVICE_MAIN_SEL_C3,
  C4: DEVICE_MAIN_SEL_C4,
  C5: DEVICE_MAIN_SEL_C5,
  C6: DEVICE_MAIN_SEL_C6,
  C123: DEVICE_MAIN_SEL_C123,
  C456: DEVICE_MAIN_SEL_C456,
  OFF: DEVICE_MAIN_SEL_OFF,
  NONE: DEVICE_MAIN_SEL_NONE
};

const DEVICE_MAIN_SEL_LABELS = {
  [DEVICE_MAIN_SEL_C1]: "C1",
  [DEVICE_MAIN_SEL_C2]: "C2",
  [DEVICE_MAIN_SEL_C3]: "C3",
  [DEVICE_MAIN_SEL_C4]: "C4",
  [DEVICE_MAIN_SEL_C5]: "C5",
  [DEVICE_MAIN_SEL_C6]: "C6",
  [DEVICE_MAIN_SEL_C123]: "C123",
  [DEVICE_MAIN_SEL_C456]: "C456",
  [DEVICE_MAIN_SEL_OFF]: "device.main.sel.off",
  [DEVICE_MAIN_SEL_NONE]: "device.main.sel.none"
};


const DEVICE_PT_PRIMARY_UNITS = {
  0:'V',
  1:'kV'
}


export {
  DEVICE_NETWORK_STATUES,
  DEVICE_NETWORK_STATUS_LABELS,
  DEVICE_TYPES,
  DEVICE_TYPE_LABELS,
  DEVICE_FIRMWARE_NONE_LABEL,
  DEVICE_SITE_NOT_ALLOCATED,
  DEVICE_SITE_LABELS,
  DEVICE_DATA_LATENCIES,
  DEVICE_DATA_LATENCY_LABELS,
  DEVICE_DI_SETUP_LABELS,
  DEVICE_DI_SETUP_VALUES,
  DEVICE_DI_SETUP_VALUES_ARRAY,
  DEVICE_BR_VALUES,
  DEVICE_BR_VALUES_ARRAY,
  DEVICE_BR_LABELS,
  DEVICE_STOP_VALUES,
  DEVICE_STOP_VALUES_ARRAY,
  DEVICE_STOP_LABELS,
  DEVICE_PARITY_VALUES,
  DEVICE_PARITY_VALUES_ARRAY,
  DEVICE_PARITY_LABELS,
  DEVICE_NETWORK_TYPES,
  DEVICE_NETWORK_TYPE_LABELS,
  DEVICE_NETWORK_SERVICE_PROVIDERS,
  DEVICE_NETWORK_SERVICE_PROVIDER_LABELS,
  DEVICE_NETWORK_SIGNAL_STRENGTH_VALUES,
  DEVICE_CONFIG_STATUS,
  DEVICE_DEMAND_METHODS,
  DEVICE_DEMAND_METHODS_ARRAY,
  DEVICE_DEMAND_METHODS_LABELS,
  DEVICE_DEMAND_INTERVALS,
  DEVICE_DEMAND_INTERVALS_ARRAY,
  DEVICE_DEMAND_INTERVAL_LABELS,
  DEVICE_WIRINGS,
  DEVICE_WIRINGS_ARRAY,
  DEVICE_WIRING_LABELS,
  DEVICE_MAIN_SELS,
  DEVICE_MAIN_SEL_LABELS,
  DEVICE_PT_PRIMARY_UNITS
};
